module.exports = __webpack_public_path__ + "static/media/Years_Alpha.ffe235d0.png";